<template>
  <div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="2">Název</th>
          <th>Množství</th>
          <th>Původní cena</th>
          <th>Sleva</th>
          <th>Cena po slevě</th>
          <th>% DPH</th>
          <th>Základ osvobozený</th>
          <th>Základ daně</th>
          <th>Výše DPH</th>
          <th colspan="2"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in order_items" :key="item.oid" :data-oid="item.oid" :data-id="item.id">
          <td><img :src="item.small_image_url" v-if="item.small_image_url" class="icoproduct"></td>
          <td>{{getProductDisplayName(item)}}



          </td>
          <td class="numeros1">
            <input type="number" class="form-control" v-model.number="item.quantity" @input="recalculateItem(item)"/>
          </td>
          <td class="numeros">
            <input type="number" step="0.01" class="form-control" 
                   :value="item.original_price" 
                   @input="onOriginalPriceChange(item, $event)"/>
          </td>
          <td class="numeros">
            <input type="number" step="0.01" class="form-control" 
                   :value="item.discount_amount" 
                   @input="onDiscountChange(item, $event)"/>
          </td>
          <td class="numeros">
            <input type="number" step="0.01" class="form-control" 
                   :value="item.amount" 
                   @input="onAmountChange(item, $event)"/>
          </td>
          <td class="numeros1">
            <select class="form-control" v-model.number="item.vat_rate" @change="recalculateVat(item)">
              <option :value="0">0%</option>
              <option :value="21">21%</option>
              <option :value="23">23%</option>
            </select>
          </td>
          <td class="numeros">
            <span>{{formatPrice(item.exempt)}}</span>
          </td>
          <td class="numeros">
            <span>{{formatPrice(item.standard_base)}}</span>
          </td>
          <td class="numeros">
            <span>{{formatPrice(item.vat)}}</span>
          </td>
          <td>
            <a @click="removeItem(item)" title="odstranit" class="text-danger">
              <svg class="svg-inline--fa fa-trash fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path>
              </svg>
            </a>
          </td>
          <td class="debuginfo">{{item.id}}</td>
        </tr>

        <tr v-if="isDiscountAsItem" class="table-warning">
          <td></td>
          <td>Sleva <b>{{payment.discount_code}}</b></td>
          <td class="numeros1">1</td>
          <td class="numeros"></td>
          <td class="numeros"></td>
          <td class="numeros">{{formatPrice(-payment.discount_amount)}}</td>
          <td class="numeros1"></td>
          <td class="numeros">0.00</td>
          <td class="numeros">{{formatPrice(-discountBase)}}</td>
          <td class="numeros">{{formatPrice(-discountVat)}}</td>
          <td colspan="2"></td>
        </tr>

        <tr>
          <th colspan="3">Celkem</th>
          <th>{{formatPrice(totalOriginalPrice)}}</th>
          <th>{{formatPrice(totalDiscount)}}</th>
          <th>{{formatPrice(isDiscountAsItem ? totalAmount - payment.discount_amount : totalAmount)}}</th>
          <th></th>
          <th>{{formatPrice(totalExempt)}}</th>
          <th>{{formatPrice(isDiscountAsItem ? totalStandardBase - discountBase : totalStandardBase)}}</th>
          <th>{{formatPrice(isDiscountAsItem ? totalVat - discountVat : totalVat)}}</th>
          <th colspan="2"></th>
        </tr>
        <tr :class="totalMismatch ? 'table-danger' : 'table-info'">
          <th colspan="5">
            Uložená cena (payment.total)
            <span v-if="totalMismatch"> — NESOUHLASÍ</span>
          </th>
          <th>{{formatPrice(payment.total)}}</th>
          <th colspan="5"></th>
        </tr>
      </tbody>
    </table>
    
    <!-- Tlačítko pro uložení změn -->
    <div v-if="hasChanges" class="alert alert-warning mt-3">
      <div class="d-flex justify-content-between align-items-center">
        <span><strong>⚠️ Máte neuložené změny</strong></span>
        <button 
          @click="saveItems" 
          :disabled="isSaving"
          class="btn btn-primary">
          <span v-if="isSaving">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Ukládám...
          </span>
          <span v-else>
            💾 Uložit změny
          </span>
        </button>
      </div>
    </div>

    <div class="form-group row mt-2">
      <div class="col-6">
        <label>Přidat produkt</label>
        <v-select 
          label="name" 
          :filterable="true" 
          :options="products"
          v-model="selected_product"
          placeholder="Vybrat produkt"
          @input="onProductSelect"
          @option:selected="onOptionSelected">
          <template #option="option">
            <div class="d-center">
              <img :src="option.small_image_url" v-if="option.small_image_url" class="icoproduct"> {{ option.name }}
            </div>
          </template>
          <template #selected-option="option">
            <div class="selected d-center">
              <img :src="option.small_image_url" v-if="option.small_image_url" class="icoproduct"> {{ option.name }}
            </div>
          </template>
        </v-select>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import {toast} from "vue3-toastify";
import 'vue3-toastify/dist/index.css';

function broofa() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

export default {
  name: "order-items2",
  components: {vSelect},
  data(){
    return{
      selected_product: {},
      products:[],
      order_items:[],
      updating: false,
      isRecalculating: false,
      hasUnsavedChanges: false,
      isSaving: false,
      productsMap: {} // Mapa product_id -> product data pro zobrazení cen
    }
  },
  props:['paymentitems', 'payment'],
  computed:{
    totalOriginalPrice(){
      return this.order_items.reduce((sum, item) => {
        return sum + (item.original_price * item.quantity)
      }, 0)
    },
    totalDiscount(){
      return this.order_items.reduce((sum, item) => {
        return sum + (item.discount_amount * item.quantity)
      }, 0)
    },
    totalAmount(){
      return this.order_items.reduce((sum, item) => {
        return sum + (item.amount * item.quantity)
      }, 0)
    },
    totalExempt(){
      return this.order_items.reduce((sum, item) => {
        return sum + (item.exempt * item.quantity)
      }, 0)
    },
    totalStandardBase(){
      return this.order_items.reduce((sum, item) => {
        return sum + (item.standard_base * item.quantity)
      }, 0)
    },
    totalVat(){
      return this.order_items.reduce((sum, item) => {
        return sum + (item.vat * item.quantity)
      }, 0)
    },
    hasChanges(){
      return this.hasUnsavedChanges
    },
    currencyId(){
      return this.payment?.currency_id || 1
    },
    currencyCode(){
      return this.currencyId === 2 ? 'EUR' : 'CZK'
    },
    isDiscountAsItem(){
      return this.payment?.discount_as_item && this.payment?.discount_amount
    },
    discountVat(){
      if (!this.isDiscountAsItem) return 0
      const vat_percent = 21
      const d = parseFloat(this.payment.discount_amount)
      return Math.round((d - (d / (1 + vat_percent / 100))) * 100) / 100
    },
    discountBase(){
      if (!this.isDiscountAsItem) return 0
      return Math.round((parseFloat(this.payment.discount_amount) - this.discountVat) * 100) / 100
    },
    computedTotal(){
      return this.isDiscountAsItem
        ? this.totalAmount - parseFloat(this.payment.discount_amount || 0)
        : this.totalAmount
    },
    totalMismatch(){
      return Math.abs(this.computedTotal - parseFloat(this.payment?.total || 0)) > 0.01
    }
  },
  methods:{
    markAsChanged(){
      if (!this.updating) {
        this.hasUnsavedChanges = true
      }
    },

    formatPrice(value){
      if (value === null || value === undefined) return '0.00'
      return parseFloat(value).toFixed(2)
    },

    getProductDisplayName(item){
      const product = this.productsMap[item.product_id]
      if (!product) return item.name
      console.log('; pro d' , item)
      const price = item.original_poduct_price
      
      return `${item.name} (${this.formatPrice(price)} ${this.currencyCode})`
    },

    onOriginalPriceChange(item, event){
      if (this.isRecalculating) return
      this.isRecalculating = true

      const val = parseFloat(event.target.value)
      if (isNaN(val)) { this.isRecalculating = false; return }

      // Nativní hodnotu inputu NEzaokrouhlujeme — ať uživatel může psát
      item.original_price = val

      // Přepočítat cenu po slevě (sleva zůstává konstantní)
      item.amount = Math.round((item.original_price - item.discount_amount) * 100) / 100
      this.recalculateVat(item)
      this.markAsChanged()

      this.$nextTick(() => { this.isRecalculating = false })
    },

    onAmountChange(item, event){
      if (this.isRecalculating) return
      this.isRecalculating = true

      const val = parseFloat(event.target.value)
      if (isNaN(val)) { this.isRecalculating = false; return }

      item.amount = val

      // Přepočítat slevu když se změní cena po slevě
      item.discount_amount = Math.round((item.original_price - item.amount) * 100) / 100
      
      this.recalculateVat(item)
      this.markAsChanged()

      this.$nextTick(() => { this.isRecalculating = false })
    },

    onDiscountChange(item, event){
      if (this.isRecalculating) return
      this.isRecalculating = true

      const val = parseFloat(event.target.value)
      if (isNaN(val)) { this.isRecalculating = false; return }

      item.discount_amount = val

      // Přepočítat cenu po slevě
      item.amount = Math.round((item.original_price - item.discount_amount) * 100) / 100
      this.recalculateVat(item)
      this.markAsChanged()

      this.$nextTick(() => { this.isRecalculating = false })
    },

    recalculateItem(item){
      // Volá se při změně quantity
      if (this.isRecalculating) return
      this.isRecalculating = true

      this.recalculateVat(item)
      this.markAsChanged()

      this.$nextTick(() => { this.isRecalculating = false })
    },

    recalculateVat(item){
      // Výpočet DPH z částky po slevě (amount)
      if (item.vat_rate === 0) {
        item.exempt = Math.round(item.amount * 100) / 100
        item.standard_base = 0
        item.vat = 0
      } else {
        const vat_multiplier = 1 + (item.vat_rate / 100)
        item.standard_base = Math.round((item.amount / vat_multiplier) * 100) / 100
        item.vat = Math.round((item.amount - item.standard_base) * 100) / 100
        item.exempt = 0
      }
      this.updateTotalDiscount()
    },

    updateTotalDiscount(){
      // Aktualizovat celkovou slevu v payment
      // Ale NE když je discount_as_item — tam je sleva na úrovni paymentu, ne položek
      if (this.payment && !this.payment.discount_as_item) {
        const total = this.totalDiscount
        this.payment.discount_amount = total
      }
    },

    loadProducts(){
      axios.get('/api/products').then( response =>{
        this.products = response.data
      })
    },

    get_product_prices(product_id, next){
      axios.get('/api/products/prices', {params: {product_id: product_id}}).then( response =>{
        next(response.data.prices)
      })
    },

    onProductSelect(a){
      if (!this.selected_product || !this.selected_product.id) return
      
      console.log('Product selected', this.selected_product.id, this.selected_product.name)
      this.get_product_prices(this.selected_product.id, (prices)=>{
        this.order_items.push(this.create_item(prices))
        this.selected_product={}
        this.markAsChanged()
      })
    },

    onOptionSelected(v){
      console.log('Option selected', v.id, v.name)
      this.get_product_prices(v.id, (prices)=>{
        this.order_items.push(this.create_item(prices))
        this.selected_product={}
        this.markAsChanged()
      })
    },

    create_item(prices){
      let p = this.selected_product
      const full_amount = parseFloat(prices.full.standard_base) + parseFloat(prices.full.exempt) + parseFloat(prices.full.vat)
      
      const item = {
        oid: broofa(),
        quantity: 1,
        product_id: p.id,
        small_image_url: p.small_image_url,
        name: p.name,
        original_price: full_amount,
        discount_amount: 0,
        amount: full_amount,
        vat_rate: p.vat_rate || 21,
        exempt: parseFloat(prices.full.exempt),
        standard_base: parseFloat(prices.full.standard_base),
        vat: parseFloat(prices.full.vat)
      }

      // Uložit produkt do mapy pro zobrazení ceny
      this.productsMap[p.id] = {
        price_czk: p.price_czk,
        price_eur: p.price_eur
      }

      console.log("Created new item", item)
      return item
    },

    removeItem(item){
      const index = this.order_items.findIndex(i => i.oid === item.oid || i.id === item.id)
      if (index > -1) {
        this.order_items.splice(index, 1)
        this.markAsChanged()
      }
    },

    get_payment_subtotal(p){
      if (!this.paymentitems) return {}

      for(var i in this.paymentitems){
        const pi = this.paymentitems[i]
        if (pi.product_id == p.product_id){
          return pi
        }
      }
      return {}
    },

    recalculateOldOrderPrices(){
      // Zkontrolovat, jestli je potřeba dopočítat původní ceny pro staré objednávky
      if (!this.order_items || this.order_items.length === 0) return
      
      const itemsTotal = this.totalAmount
      const paymentTotal = this.payment?.total || 0
      const paymentDiscount = this.payment?.discount_amount || 0
      
      // Podmínky pro detekci staré objednávky:
      
      // 1. Chybí original_price nebo je 0
      const hasMissingOriginalPrice = this.order_items.some(item => 
        !item.original_price || item.original_price === 0
      )
      
      // 2. Original_price se rovná amount (žádné slevy rozpočítané)
      const originalEqualsAmount = this.order_items.every(item =>
        item.original_price === item.amount
      )
      
      // 3. Payment.total je menší než součet amount položek
      const paymentTotalLessThanItems = paymentTotal < itemsTotal && paymentTotal > 0
      
      // 4. Existuje payment.discount_amount, ale položky nemají discount_amount
      const hasDiscountButNoItemDiscounts = paymentDiscount > 0 && 
        this.order_items.every(item => !item.discount_amount || item.discount_amount === 0)
      
      // Pokud splňuje jakoukoliv podmínku, dopočítat
      if (hasMissingOriginalPrice || 
          (originalEqualsAmount && hasDiscountButNoItemDiscounts) ||
          paymentTotalLessThanItems) {
        
        console.log('🔍 Detekována stará objednávka, dopočítávám původní ceny...')
        console.log('  - hasMissingOriginalPrice:', hasMissingOriginalPrice)
        console.log('  - originalEqualsAmount:', originalEqualsAmount, 'hasDiscountButNoItemDiscounts:', hasDiscountButNoItemDiscounts)
        console.log('  - paymentTotalLessThanItems:', paymentTotalLessThanItems, `(${paymentTotal} < ${itemsTotal})`)
        console.log('  - paymentDiscount:', paymentDiscount)
        
        // Vypočítat celkovou slevu
        let totalDiscount = paymentDiscount
        
        // Pokud payment.discount_amount není nastaveno, vypočítat z rozdílu
        if (totalDiscount === 0 && paymentTotalLessThanItems) {
          totalDiscount = itemsTotal - paymentTotal
          console.log('  - Vypočítaná sleva z rozdílu:', totalDiscount)
        }
        
        this.distributeDiscountToItems(totalDiscount)
      } else {
        console.log('✓ Objednávka má správně nastavené původní ceny')
      }
    },

    distributeDiscountToItems(totalDiscount){
      if (totalDiscount <= 0) {
        console.log('  - Žádná sleva k rozpočítání')
        return
      }
      
      const itemsTotal = this.totalAmount
      
      if (itemsTotal === 0) {
        console.log('  - Celková částka položek je 0, nelze rozpočítat slevu')
        return
      }
      
      console.log(`  - Rozpočítávám slevu ${totalDiscount} mezi položky (celkem: ${itemsTotal})`)
      
      this.order_items.forEach(item => {
        // Proporcionální podíl této položky
        const amount = parseFloat(item.amount) || 0
        const itemProportion = amount / itemsTotal
        
        // Dopočítat slevu pro tuto položku
        const itemDiscount = totalDiscount * itemProportion
        
        // Nastavit původní cenu
        item.original_price = parseFloat((amount + itemDiscount).toFixed(2))
        item.discount_amount = parseFloat(itemDiscount.toFixed(2))
        
        console.log(`    - ${item.name}: sleva ${item.discount_amount.toFixed(2)}, původní cena ${item.original_price.toFixed(2)}`)
      })
      
      console.log('✓ Původní ceny dopočítány')
    },

    async saveItems() {
      if (this.isSaving) return
      
      this.isSaving = true
      
      try {
        // Připravit data ve formátu Rails nested attributes
        const payload = {
          order: {
            payment_attributes: {
              id: this.payment.id,
              subtotals_attributes: this.order_items.map(item => ({
                id: typeof item.id === 'number' ? item.id : null, // číslo = existující, jinak nová položka
                product_id: item.product_id,
                quantity: parseFloat(item.quantity) || 1,
                amount: parseFloat(item.amount) || 0,
                original_price: parseFloat(item.original_price) || 0,
                discount_amount: parseFloat(item.discount_amount) || 0,
                vat_rate: parseInt(item.vat_rate) ?? 21,
                exempt: parseFloat(item.exempt) || 0,
                standard_base: parseFloat(item.standard_base) || 0,
                vat: parseFloat(item.vat) || 0
              }))
            }
          }
        }
        
        const orderId = window.location.pathname.match(/\/orders\/(\d+)/)[1]
        const response = await axios.patch(`/orders/${orderId}/update-items`, payload)
        
        if (response.data.success) {
          toast.success(response.data.message || 'Změny byly uloženy')
          this.hasUnsavedChanges = false
          
          // Aktualizovat data z odpovědi
          const newSubtotals = JSON.parse(response.data.subtotals)
          this.refreshFromSubtotals(newSubtotals)
        }
      } catch (error) {
        console.error('Chyba při ukládání:', error)
        const errorMsg = error.response?.data?.errors?.join(', ') || 'Nepodařilo se uložit změny'
        toast.error(errorMsg)
      } finally {
        this.isSaving = false
      }
    },
    
    refreshFromSubtotals(subtotals) {
      // Aktualizovat order_items z nově načtených dat
      this.updating = true
      this.order_items = []
      this.productsMap = {}
      
      subtotals.forEach(ps => {
        this.order_items.push({
          id: ps.id,
          oid: ps.id,
          product_id: ps.product_id,
          small_image_url: ps.product?.small_image_url,
          name: ps.product?.name,
          quantity: parseFloat(ps.quantity) || 1,
          original_price: parseFloat(ps.original_price) || 0,
          discount_amount: parseFloat(ps.discount_amount) || 0,
          amount: parseFloat(ps.amount) || 0,
          vat_rate: parseInt(ps.vat_rate ?? 21),
          exempt: parseFloat(ps.exempt) || 0,
          standard_base: parseFloat(ps.standard_base) || 0,
          vat: parseFloat(ps.vat) || 0
        })
        
        // Uložit produkt do mapy pro zobrazení ceny
        if (ps.product) {
          this.productsMap[ps.product_id] = {
            price_czk: ps.product.price_czk,
            price_eur: ps.product.price_eur
          }
        }
      })
      
      this.updating = false
    }
  },
  
  mounted(){
    // Načíst existující položky z paymentitems
    if (this.paymentitems && this.paymentitems.length > 0) {
      this.updating = true
      
      for(var i in this.paymentitems){
        let pi = this.paymentitems[i]
        const item = {
          id: pi.id,
          oid: pi.id,
          product_id: pi.product_id,
          small_image_url: pi.product?.small_image_url,
          name: pi.product?.name,
          quantity: parseFloat(pi.quantity) || 1,
          original_price: parseFloat(pi.original_price || pi.amount+(this.payment.discount_amount || 0) ) || 0,
          discount_amount: parseFloat(pi.discount_amount ?? this.payment.discount_amount) || 0,
          amount: parseFloat(pi.amount) || 0,
          vat_rate: parseInt(pi.vat_rate ?? pi.product?.vat_rate ?? 21),
          exempt: parseFloat(pi.exempt) || 0,
          standard_base: parseFloat(pi.standard_base) || 0,
          vat: parseFloat(pi.vat) || 0,
          original_poduct_price: parseFloat(pi.original_poduct_price) || 0
        }

        this.order_items.push(item)
        
        // Uložit produkt do mapy pro zobrazení ceny
        if (pi.product) {
          this.productsMap[pi.product_id] = {
            price_czk: pi.product.price_czk,
            price_eur: pi.product.price_eur
          }
        }
      }
      
      this.updating = false
    }

    this.loadProducts()
  }
}
</script>

<style scoped>
td.numeros {
  max-width: 120px; 
  width: 120px;
}

td.numeros1 {
  max-width: 100px; 
  width: 100px;
}

.icoproduct {
  max-width: 40px;
  max-height: 40px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.debuginfo {
  font-size: 10px;
  color: #999;
}
</style>